import { isMobileOnly } from 'react-device-detect';
import { IStyles } from '@interfaces/styles';
import { colors } from '@constants/colors';

export const useStyles = (): IStyles => {
  return {
    root: {
      '& .MuiDivider-root': {
        my: isMobileOnly ? 0.5 : 1.5,
        backgroundColor: colors.white_20,
      },
    },
    menu: {
      color: colors.white,
      padding: 0,
      gap: 0.5,
    },
    link: {
      paddingX: 1,
      paddingY: 0.75,
      borderRadius: '10px',

      '& .MuiListItemIcon-root': {
        minWidth: 28,
      },

      '&:hover': {
        backgroundColor: colors.white_10,
      },
    },
    linkText: {
      minWidth: 0,

      '& .MuiListItemText-primary': {
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: '0.02em',
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    menuOptionMobile: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  };
};
